import { render, staticRenderFns } from "./Redeem10.vue?vue&type=template&id=51a926d5&scoped=true&"
import script from "./Redeem10.vue?vue&type=script&lang=js&"
export * from "./Redeem10.vue?vue&type=script&lang=js&"
import style0 from "./Redeem10.vue?vue&type=style&index=0&id=51a926d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a926d5",
  null
  
)

export default component.exports